module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Jbcd.9b35d6b4.png";